import { AvatarFallback, Avatar, AvatarImage } from '@e2n/ui';
import { cn } from '@/lib/utils';
import { faImage } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { useProfile } from '@/hooks';
import { Fragment } from 'react/jsx-runtime';
import { useUpdateNewsStatus } from '@/domain/navigation/features/navigation/hooks/useUpdateNewsStatus/useUpdateNewsStatus';
import { useNews } from '@/domain/navigation/features/navigation/hooks/useNews/useNews';

export function NewsfeedItemsList({
  handleClose,
}: {
  handleClose: () => void;
}) {
  const { news } = useNews();
  const location = useLocation();
  const [updateNewsStatus] = useUpdateNewsStatus();
  const profile = useProfile();
  const navigate = useNavigate();

  function markNewsItemAsReadById(id: string) {
    updateNewsStatus({ newsItemId: id, istGelesen: true })
      .catch((err) => {
        Sentry.captureException(`Could not update news status: ${err}`, {
          tags: { email: profile.manager.email },
        });
      })
      .finally(() => {
        navigate(`/news/${id}`, { state: { background: location } });
        handleClose();
      });
  }

  return news.map((item) => (
    <Fragment key={item.id}>
      <Link
        onClick={(e) => {
          e.preventDefault();
          markNewsItemAsReadById(item.id);
        }}
        to={{
          pathname: `/news/${item.id}`,
        }}>
        <div key={item.id} className="relative flex items-center gap-3 ps-2">
          <Avatar className="w-8 h-8">
            <AvatarImage
              className="object-cover object-left"
              src={item.bildUrl}
              alt={item.titel}
            />
            <AvatarFallback>
              <FontAwesomeIcon
                className="text-neutrals-800"
                icon={faImage}
                size="lg"
              />
            </AvatarFallback>
          </Avatar>
          <div className="flex flex-col gap-0.5 items-start text-sm flex-1 min-w-0 mr-6">
            <div
              className={cn(
                'truncate w-full',
                item.istGelesen && 'font-semibold',
              )}>
              {item.titel}
            </div>
            <div className="text-neutrals-700">
              {item.veroeffentlichtAmRelative()}
            </div>
          </div>

          {!item.istGelesen && (
            <span className="absolute top-0 right-2 w-2 h-2 rounded-full bg-primary-blue-600" />
          )}
        </div>
      </Link>
      <hr className="last:hidden m-0 text-neutrals-300" />
    </Fragment>
  ));
}
